import { parseDate } from "utils/moment-utils";

export interface ExperienceGroupSizeLimit {
    experienceId: number;
    minGroupSize: number | null;
    maxGroupSize: number | null;
}

export enum BookedStatus {
    Undefined = 0,
    Available = 1,
    WaitList = 2,
    FullyBooked = 3,
}

export enum DayStateStatus {
    Undefined = 0,
    Closed = 1,
    Open = 3,
}

export class DayState {
    day: IMoment;
    unitId: number;
    sectionId: number;
    state: DayStateStatus;
    availableSeats: number[] | null;
    waitListSeats: number[] | null;
    bookedStatus: BookedStatus;
    activeExperienceIds: number[];
    minGroupSize: number | null;
    maxGroupSize: number | null;
    experienceGroupSizeLimits: ExperienceGroupSizeLimit[];
    /** Open, and every non-closed time set on the section-day is a text row. */
    onlyTextRows: boolean;

    constructor(values?: DayState) {
        this.day = parseDate(values?.day).local();
        this.unitId = values?.unitId ?? 0;
        this.sectionId = values?.sectionId ?? 0;
        this.state = values?.state ?? DayStateStatus.Undefined;
        this.availableSeats = values?.availableSeats ?? null;
        this.waitListSeats = values?.waitListSeats ?? null;
        this.bookedStatus = values?.bookedStatus ?? BookedStatus.Undefined;
        this.activeExperienceIds = values?.activeExperienceIds ?? [];
        this.minGroupSize = values?.minGroupSize ?? null;
        this.maxGroupSize = values?.maxGroupSize ?? null;
        this.experienceGroupSizeLimits = values?.experienceGroupSizeLimits ?? [];
        this.onlyTextRows = values?.onlyTextRows ?? false;
    }
}
